<template>
  <div>
    <div class="text-left">
      <div class="section-icon">⛳</div>
    </div>

    <!-- block -->
    <div class="block mt-4">
      <h1>Page not found.</h1>
      <p class="mt-4">
        It looks like you wandered where no man has been before! Unfortunately
        for you, there is nothing here.
      </p>
    </div>
    <!-- ./ block -->
  </div>
</template>

<script>
export default {
  name: 'PageNotFound'
}
</script>

<style></style>
